import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import { ReviewSparkle } from "components/icons/ReviewSparkle";
import { pluralize } from "utils/pluralize";
import { useGetExtractionReviewQuery } from "v2/store/entityDocumentsApi";
import { countReviewDocuments } from "v2/utils/countReviewDocuments";
import { hasUnsavedReview } from "v2/utils/countReviewFields";
import { ReviewExtractedInfoModal } from "./ReviewExtractedInfoModal";

type SetupReviewBannerProps = {
  entityId: string;
};

const TITLE = "Review and confirm extracted information";

export const SetupReviewBanner = ({ entityId }: SetupReviewBannerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: review } = useGetExtractionReviewQuery(
    { entityId },
    { skip: !entityId }
  );

  const documentCount = countReviewDocuments(review);

  const showBanner = hasUnsavedReview(review);

  let title = TITLE;
  if (documentCount > 0) {
    title = `${TITLE} from ${pluralize(
      documentCount,
      "document",
      "documents"
    )}`;
  }

  const handleOpen = (): void => setIsOpen(true);
  const handleClose = (): void => setIsOpen(false);

  if (!showBanner && !isOpen) return null;

  return (
    <>
      {showBanner && (
        <div className="t-flex t-shrink-0 t-items-center t-justify-between t-gap-10 t-rounded-xl sm:t-flex-col sm:t-items-start sm:t-gap-3 t-border t-border-solid t-border-purple t-px-4 t-py-3">
          <div className="t-flex t-min-w-0 t-flex-col t-gap-0.5">
            <div className="t-flex t-items-center t-gap-1.5 t-text-subtext t-text-text-60">
              <ReviewSparkle className="t-h-4 t-w-4 t-shrink-0" />
              {title}
            </div>

            <p className="t-m-0 t-text-body-sm-lite t-text-text-30">
              Review each field and confirm it&apos;s correct to fill the
              information in the fields below
            </p>
          </div>

          <Button
            type="button"
            customType="primary"
            size="small"
            onClick={handleOpen}
          >
            Review &amp; confirm
          </Button>
        </div>
      )}

      <ReviewExtractedInfoModal
        entityId={entityId}
        isOpen={isOpen}
        onClose={handleClose}
      />
    </>
  );
};
